import { render, staticRenderFns } from "./CoachRequired.vue?vue&type=template&id=60028cd2&scoped=true"
import script from "./CoachRequired.vue?vue&type=script&lang=js"
export * from "./CoachRequired.vue?vue&type=script&lang=js"
import style0 from "./CoachRequired.vue?vue&type=style&index=0&id=60028cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60028cd2",
  null
  
)

export default component.exports